module.exports = __webpack_public_path__ + "static/media/pfsLogo.6b4e844c.png";